const enum PositioningEnum {
  Left = 'left',
  Center = 'centre',
  Right = 'right',
}

export default PositioningEnum;
